module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li class="xAction xActionButton xActionHybrid xActionAuth'+
((__t=( providerName ))==null?'':_.escape(__t))+
'">\n\n	<a class="xButton xAuthButton xAction'+
((__t=( providerName ))==null?'':_.escape(__t))+
' xProvider'+
((__t=( providerName ))==null?'':_.escape(__t))+
'" data-ngx-network="'+
((__t=( providerName ))==null?'':_.escape(__t))+
'" data-ngx-provider="'+
((__t=( providerName ))==null?'':_.escape(__t))+
'">\n		';
 if(typeof(hasIcon)!=="undefined"){
__p+='\n			<i class="xIcon xIcon'+
((__t=( providerName ))==null?'':_.escape(__t))+
'"></i>\n		';
 } 
__p+='\n		<span>'+
((__t=( buttonLabel ))==null?'':_.escape(__t))+
'</span>\n	</a>\n\n</li>\n';
}
return __p;
};
